export type ShallowComputedGetter<T> = () => T;
export type ShallowComputedSetter<T> = (value: T) => void;
export type ShallowComputedOptions<T = any> =
    | ShallowComputedGetter<T>
    | {
          get: ShallowComputedGetter<T>;
          set: ShallowComputedSetter<T>;
      };

export const useShallowComputed = <T = any>(
    options: ShallowComputedOptions<T>,
) => {
    return customRef<T>((track, trigger) => {
        return {
            get(): T {
                track();

                return typeof options === "function"
                    ? options()
                    : options.get();
            },
            set(value: T): void {
                if (typeof options !== "function") {
                    const result: any = options.set(value);

                    if (result instanceof Promise) {
                        result.finally(() => trigger());
                        return;
                    }
                }

                trigger();
            },
        };
    });
};
